export const generateBaseUrl = () => {
  if (window.location.hostname == "localhost") {
    return 'http://localhost:8080/api';
  }
  return 'https://recipes.grantharper.org/api';

}

export const IMAGE_BASE_URL = 'https://hkh-recipe-images.s3.amazonaws.com/';